<template>
    <main id="main__container">
        <slot></slot>
    </main>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 1500px) {
    #main__container {
        padding: 0 !important;
    }
}

#main__container {
    max-width: 1440px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 20px;
    margin-bottom: 20px;
    padding: 0 30px;
}

@media only screen and (max-width: 550px) {
    #main__container {
        padding: 0 15px;
    }
}
</style>
